var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.org.personal)?_c('div',{staticClass:"subtle-box p-box-more t-center"},[_c('h1',[_vm._v("There is only one you.")]),_vm._v(" "),_c('p',[_vm._v("You can't add team members to your personal account.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"btn btn-a",attrs:{"to":{name:'orgs'}}},[_vm._v("Manage organisations")])],1)]):_c('div',[_c('p',[_c('button',{staticClass:"btn-a",on:{"click":function($event){return _vm.openInviteEditor(_vm.org)}}},[_c('i',{staticClass:"fa fa-envelope btn_icon"}),_vm._v("Invite a new user")])]),_vm._v(" "),_c('div',{staticClass:"raised-box"},[_c('List',{attrs:{"loading":!(_vm.users_loaded && _vm.invites_loaded),"results":_vm.team_list,"columns":[
					{
						usericon:1,
					},
					{
						label:'Name',
						name:'name',
					},
					{
						label:'Email',
						name:'email',
					},
					{
						label:'Status',
						name:'status',
					},
					{
						label:'Options',
						buttons : function (item) {

							if((item.user||{}).id){
								return [
									{
										text : 'Remove user',
										confirm:'Are you sure you want to remove this user?',
										class : 'btn-outline-warning' + ( item.loading ? ' _btn_submitting-grey' :'' ),
										action : function (){ _vm.removeUser(item.user); },
									} ];
							}

							return [
								{
									text : 'Cancel invite',
									confirm:'Are you sure you want to cancel this invite?',
									class : 'btn-outline-warning' + ( item.loading ? ' _btn_submitting-grey' :'' ),
									action : function (){ _vm.cancelInvite(item.invite); },
								} ];
						},
					} ]}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Want to share configs with others?")]),_vm._v(" Start a new organisation:")])}]

export { render, staticRenderFns }